/* remove inline styles from hero carousel button */

$(".banner7-content .banner7-readmore a").css('display', '');
$(".banner7-content .banner7-readmore a").attr("style", "");
$(".banner7-content .banner7-readmore a").attr("onmouseover", "");
$(".banner7-content .banner7-readmore a").attr("onmouseout", "");

/* add pp note below newsletter sign up box */
$("<div class='ppNote'>By completing this form you are agreeing to the terms of our <a href='/pages/privacy-cookies-policies' title='' target='_blank'>privacy notice</a> regarding collection/storage and usage of your personal data.</div>").insertAfter(".newletter-subscribe-container #subscribe-normal");



/* remove recently viewed block from product page */
$('.related-products').nextAll('.container').hide();


/* move homepage introtext p below the h1 */
var div=$('#shopify-section-1602682587905 .static1-elomus1 .module-title p');
var sopra=$('#shopify-section-1602682587905 .static1-elomus1 .module-title h2');
$( div ).insertAfter( sopra );

/* add icons image below last p in home universal charger banner */
$('<img src="https://cdn.shopify.com/s/files/1/0497/7174/1344/t/2/assets/universalChargerIcons.png">').insertAfter("#shopify-section-1619295723f794aca2 p.addIMGbelowMe");


/* add emblems image to LHS of FTA product page, IF url is FTA product, serving the desktop or mobile version based on screenwidth - ON LOAD */
/*
function emblemsPromoBannerLogic() {
    if (window.location.href.indexOf("/products/fuel-the-adventure") > -1) {
      if ($(window).width() < 650) {
   		$("<div class='emblemsProductPromoWrapper'><a href='/products/emblems' title='Buy 4 high quality domed emblems for just £5.99'><img src='https://cdn.shopify.com/s/files/1/0497/7174/1344/t/2/assets/emblemsBanner-mobile.jpg' title='Buy 4 high quality domed emblems for just £5.99' alt='Buy 4 high quality domed emblems for just £5.99' </a></div>").insertAfter(".owl-carousel");      
	  }
	  else {
   		$("<div class='emblemsProductPromoWrapper'><a href='/products/emblems' title='Buy 4 high quality domed emblems for just £5.99'><img src='https://cdn.shopify.com/s/files/1/0497/7174/1344/t/2/assets/emblemsBanner.jpg' title='Buy 4 high quality domed emblems for just £5.99' alt='Buy 4 high quality domed emblems for just £5.99' </a></div>").insertAfter(".owl-carousel");      
	  }		
}
}
$(document).ready(function() { emblemsPromoBannerLogic(); });
// check emblems banner and changes src for mobile / desktop based on screen width
function emblemsPromoBannerIMGtype() {
    if (window.location.href.indexOf("/products/fuel-the-adventure") > -1) {
      if ($(window).width() < 650) {
	  $(".emblemsProductPromoWrapper img").attr("src","https://cdn.shopify.com/s/files/1/0497/7174/1344/t/2/assets/emblemsBanner-mobile.jpg");
      }
	  else {
   	  $(".emblemsProductPromoWrapper img").attr("src","https://cdn.shopify.com/s/files/1/0497/7174/1344/t/2/assets/emblemsBanner.jpg");
      }		
}
}
$(window).resize(function() { emblemsPromoBannerIMGtype(); });
*/


/* USE THIS - revised approach - injecting desktop and mobile banners in their relevant locations - then letting CSS show/hide them */
/*function injectemblemsPromoBanners() {
if (window.location.href.indexOf("/products/fuel-the-adventure") > -1) {
$("<div class='emblemsProductPromoWrapper emblemsProductPromoWrapper_mobile'><a href='/products/emblems' title='Buy 4 high quality domed emblems for just £5.99'><img src='https://cdn.shopify.com/s/files/1/0497/7174/1344/t/2/assets/emblemsBanner-mobile.jpg' title='Buy 4 high quality domed emblems for just £5.99' alt='Buy 4 high quality domed emblems for just £5.99' </a></div>").insertAfter("#product");      
$("<div class='emblemsProductPromoWrapper emblemsProductPromoWrapper_desktop'><a href='/products/emblems' title='Buy 4 high quality domed emblems for just £5.99'><img src='https://cdn.shopify.com/s/files/1/0497/7174/1344/t/2/assets/emblemsBanner.jpg' title='Buy 4 high quality domed emblems for just £5.99' alt='Buy 4 high quality domed emblems for just £5.99' </a></div>").insertAfter(".owl-carousel");      
}		
}
$(document).ready(function() { injectemblemsPromoBanners(); });*/